import { useParams } from "react-router";

export function withParams(Child) {
  return (props) => {
    const params = useParams();
    return <Child { ...props } params={params} />;
  }
}